import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/categoriaFormulario/importer/categoriaFormularioImporterActions';

export default importerReducers(actions);
